/**
 * Enum representing possible statuses of an entity.
 */
export enum Status {
    /** The entity is active and operational */
    Active = "Active",

    /** The entity is inactive and not in use */
    Inactive = "Inactive",

    /** The entity is under maintenance */
    Maintenance = "Maintenance"
}
